// noinspection NpmUsedModulesInstalled
import $ from 'jquery';
import { attachReselectCheckboxesEvent } from './customEventListeners';
import './style.scss';

const HTML_CLASS = 'compare-bar-isopen';
const IS_SHOWN = 'is-shown';
const IS_HIDDEN = 'is-hidden';

function attachCompareBar(table) {
  const $form = $(table).parent('form[name="compareForm"]');
  const $compareBar = $form.find('.js-compare-bar__popup');
  const $compareBarHeading = $form.find('.js-compare-bar__heading');
  const $compareBarItems = $form.find('.js-compare-bar__items');

  let maxItems = 4;

  // Stores all selected product info
  let selectedItems = [];

  // Stores all selected product ids
  let selectedItemsId = [];

  $compareBar
    .on('selectionEnd', updateHeading)
    .on('itemChecked submitted', trackEvent)
    .on('render', setMaxItemsNumber);

  $(window).on('resize', setMaxItemsNumber);

  function trackEvent({ type }, data = {}) {
    const {
      title = null,
      itemsBeingCompared = [],
    } = data;

    const eventMap = {
      itemChecked: () => ['Compare checkbox', title],
      submitted: () => ['Shortlist', itemsBeingCompared.join(', ')],
    };

    const event = eventMap[type];

    if (!event) {
      return;
    }

    const category = 'Table';
    const [action, label = ''] = event();

    $.trackEvent(category, action, label, undefined, true);
  }

  function setMaxItemsNumber() {
    maxItems = isViewportMobileCheck() ? 2 : 4;
  }

  function isViewportMobileCheck() {
    return window.innerWidth < 601;
  }

  // noinspection JSUnusedLocalSymbols
  function updateHeading(e, { current, total }) {
    $compareBarHeading.attr(
      'data-selection-state',
      `${current} of ${total} selected`,
    );
  }

  function show($element) {
    $element.addClass(IS_SHOWN).removeClass(IS_HIDDEN);
    $('html').addClass(HTML_CLASS);

    $compareBar.trigger('shown');
  }

  function hide($element) {
    selectedItems = [];
    selectedItemsId = [];
    $element.removeClass(IS_SHOWN).addClass(IS_HIDDEN);
    $('html').removeClass(HTML_CLASS);

    $compareBar.trigger('hidden');
  }

  function renderCompareBar() {
    $compareBar.trigger('render');

    if (selectedItems.length > 0) {
      $compareBarItems.find('li').each((i, element) => {
        const item = selectedItems[i];
        let itemHTML = '';
        if (typeof item !== 'undefined') {
          $(element).removeClass('empty');

          // Add item details on compare bar item
          const attrDataId = `data-id="${item.id}"`;
          const attrDataCheckboxId = `data-checkbox-id="${item.checkboxUniqueID}"`;
          itemHTML = `<div ${attrDataId} ${attrDataCheckboxId} class="compare-bar__user-card">
            <img class="compare-bar__img" width="80" height="32" src="${item.img}">
            <button class="compare-bar__delete-button js-comparison-delete" ${attrDataId}>
              <i class="icon-cross"></i>
            </button>
          </div>`;
        } else {
          $(element).addClass('empty');
        }

        $(element).html(itemHTML);
      });
    } else {
      // Removes items to compare bar item containers
      $compareBarItems.find('li').html('');
    }

    const isCompareBarShown = $compareBar.hasClass(IS_SHOWN);
    const shouldHideCompareBar = isCompareBarShown && selectedItems.length === 0;
    const shouldShowCompareBar = !isCompareBarShown && selectedItems.length > 0;

    if (shouldHideCompareBar) {
      hide($compareBar);
    } else if (shouldShowCompareBar) {
      show($compareBar);
    }

    $compareBar.trigger('selectionEnd', {
      current: selectedItems.length,
      total: maxItems,
    });
  }

  // Stores all item IDs that is needed in Comparison Modal
  function storeSelectedItemIds() {
    $form.find('.js-compare-bar-items-id').val(selectedItemsId.join(','));
  }

  function uncheckAttribute(input) {
    // noinspection UnnecessaryLocalVariableJS
    const $inputElem = input;
    $inputElem.checked = false;
  }

  /**
   * Adds item if selected items are less than maxItems,
   * Otherwise uncheck input selected
   *
   * @param input
   * @param item - selected item info {id, img, title}
   */
  function selectItem(input, item) {
    if (selectedItems.length < maxItems) {
      selectedItems.push(item);
      selectedItemsId.push(item.id);

      const { title } = item;

      $compareBar.trigger('itemChecked', { title });
    } else {
      uncheckAttribute(input);
    }
    storeSelectedItemIds();
  }

  const parseId = (id) => {
    let parsedId = Number(id);
    if (isNaN(parsedId)) {
      parsedId = id;
    }
    return parsedId;
  };

  /**
   * Removes item
   *
   * @param input
   * @param id - selected item id
   */
  function unselectItem(input, id) {
    const parsedId = parseId(id);

    selectedItems = selectedItems.filter(
      item => parseId(item.id) !== parsedId,
    );
    selectedItemsId = selectedItemsId.filter(
      itemId => parseId(itemId) !== parsedId,
    );

    uncheckAttribute(input);
    storeSelectedItemIds();

    $compareBar.trigger('itemUnchecked');
  }

  function clearSelections() {
    selectedItems = [];
    selectedItemsId = [];
    storeSelectedItemIds();
    renderCompareBar();

    $compareBar.trigger('itemsCleared');
  }

  $form.on('change', 'input[type=checkbox]', ({ currentTarget: input }) => {
    const $this = $(input);
    const item = {
      title: $this.attr('_productname'),
      id: $this.attr('value'),
      // Get image from table
      img: $this.closest('tr').find('.comparison-table__product img').attr('src'),
    };

    // Store checkbox unique ID
    item.checkboxUniqueID = $this.attr('id');

    if (input.checked) {
      selectItem(input, item);
    } else {
      unselectItem(input, item.id);
    }
    // Hide other compare bars (for multiple tables)
    $('.js-compare-bar__popup').not($compareBar).removeClass(IS_SHOWN).addClass(IS_HIDDEN);
    // Render compare bar for current table
    renderCompareBar();
  });

  $form.on('click', '.js-comparison-delete', function deleteCallback(e) {
    e.preventDefault();
    const $this = $(this);
    const checkboxID = $this.parent().data('checkbox-id');
    unselectItem(document.getElementById(`${checkboxID}`), $this.data('id'));
    renderCompareBar();
  });

  $form.on('click', '.js-compare-bar__clear-button', () => clearSelections());

  window._templateTable_compareClearSelections = clearSelections; // Uses in fhl-wizard

  $(document).on('shown', '#compare-products-modal', () => hide($compareBar));
  $(document).on('hidden', '#compare-products-modal', () => {
    const nativeElem = $form.get(0);
    nativeElem.querySelectorAll('input[type=checkbox]').forEach(uncheckAttribute);
    clearSelections();
  });

  $form.on('click', '.t_table_comparebutton', () => {
    const itemsBeingCompared = selectedItems.map(item => item.title);
    $compareBar.trigger('submitted', { itemsBeingCompared });
  });

  attachReselectCheckboxesEvent(table.parentNode);
}

export default attachCompareBar;
